import React, {FC} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../../constants/colors';
import {UnstyledLink} from '../../../atoms/UnstyledLink/UnstyledLink';
import {Icon} from '../../../atoms/Icon/Icon';
import {GenericIconName} from '../../../atoms/Icon/IconName';

export const VipLogo: FC<{
  dataTestId?: string;
  vipLandingPageUrl: string;
}> = ({dataTestId, vipLandingPageUrl}) => {
  return (
    <VipLogoLink to={vipLandingPageUrl} data-testid="AboutNameLogoVip">
      <VipIcon
        asset={GenericIconName.Vip}
        fill={COLORS.Black}
        data-testid={dataTestId}
      />
    </VipLogoLink>
  );
};

const VipLogoLink = styled(UnstyledLink)`
  height: 100%;
`;

const VipIcon = styled(Icon)`
  width: 31px;
  height: 100%;
`;
